<template>
  <div class="vx-card" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '23') != null">
    <h1 class="card-bg p-6 text-center mt-4">PERSONEL DEPO YÖNETİMİ</h1>
    <div class="proje_cards pt-6 mb-5">
      <div class="proje_card left mb-5">
        <h2 class="card-bg p-6 mb-3 text-center hoverHeading" @click="showSearchWarehouse = !showSearchWarehouse">
          <span class="mr-2"><feather-icon icon="SearchIcon" svgClasses="h-6 w-6" /></span><span>Personel Depo Arama</span>
        </h2>

        <div v-if="showSearchWarehouse" class="card-bg p-5">
          <form @submit.prevent="getWarehouseUser()">
            <div class="inputs tFlex tFlex_ai-s gap-1 mb-5">
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Personel</b></label>
                <v-select @input="getWarehouseUser()" name="Id" v-model="warehouseUserSearch.userId" placeholder="Personel Seçiniz" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
                <!-- <vs-input type="number" style="width: 100%;" v-model="warehouseUserSearch.userId" /> -->
              </div>
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Depo</b></label>
                <v-select @input="getWarehouseUser()" name="Id" v-model="warehouseUserSearch.warehouseId" placeholder="Depo Seçiniz" :options="warehouseList" label="value" class="w-full" :reduce="(row) => row.id">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>

            <div class="tFlex tFlex_column tFlex_ai-c tFlex_jc-c mb-3 gap-1">
              <vs-button color="success" class="width-110">Ara</vs-button>
            </div>
          </form>
        </div>
      </div>
      <div class="right mb-5">
        <h2 class="mb-3 card-bg text-center hoverHeading proje_card p-6" @click="showAddWarehouse = !showAddWarehouse">
          <span class="mr-2"><feather-icon icon="EditIcon" svgClasses="h-6 w-6" /></span><span>Personel Deposu Oluştur</span>
        </h2>
        <div v-if="showAddWarehouse" class="card-bg p-5">
          <div class="projects tFlex gap-1 mb-3">
            <div class="left flex-1">
              <div class="mb-5">
                <label class="text-sm"><b>Personel</b></label>
                <v-select name="Id" v-model="warehouseUserItem.userId" placeholder="Personel Seçiniz" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>
            <div class="right flex-1">
              <div class="left flex-1">
                <div class="mb-5">
                  <label class="text-sm"><b>Depo</b></label>
                  <v-select name="Id" v-model="warehouseUserItem.warehouseId" placeholder="Depo Seçiniz" :options="warehouseList" label="value" class="w-full" :reduce="(row) => row.id">
                    <span slot="no-options">Eşleşen Veri Yok</span>
                  </v-select>
                </div>
              </div>
            </div>
          </div>

          <div class="tFlex tFlex_jc-c">
            <vs-button color="success" class="width-220" @click="SaveWarehouseUser(warehouseUserItem, 'Insert', '')">Personel Deposu Ekle</vs-button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-bg mb-5 p-5">
      <h2 class="text-center hoverHeading">
        <span class="mr-2"><feather-icon icon="BriefcaseIcon" svgClasses="h-6 w-6" /></span><span>Personel Depoları</span>
      </h2>

      <div class="vx-row w-full">
        <div class="vx-col w-full mb-5">
          <vs-table search :maxItems="10" :pagination="true" :data="warehouseUserList">
            <template slot="thead">
              <vs-th>Personel Id</vs-th>
              <vs-th>Personel Adı</vs-th>
              <vs-th>Depo Id</vs-th>
              <vs-th>Depo Adı</vs-th>
              <vs-th>İşlemler</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="i" v-for="(tr, i) in data">
                <template v-if="tr.userId">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap; width: 10%;">
                    <b>{{ tr.userId }}</b>
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap; width: 20%;">
                    <v-select name="Id" style="width: 300px;" v-model="tr.userId" :options="userList" label="userName" :reduce="(row) => row.userId"> </v-select>
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap; width: 10%;">
                    <b>{{ tr.warehouseId }}</b>
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap; width: 20%;">
                    <v-select name="Id" style="width: 300px;" v-model="tr.warehouseId" :options="warehouseList" label="value" :reduce="(row) => row.id"> </v-select>
                  </vs-td>
                  <vs-td style="width: 10%;">
                    <feather-icon icon="TrashIcon" title="Sil" svgClasses="h-6 w-6 hover:text-warning text-danger cursor-pointer" @click.stop="SaveWarehouseUser(tr, 'Delete', 'Personel Deposu Silinecektir')" />
                    <feather-icon icon="EditIcon" title="Güncelle" svgClasses="h-6 w-6 ml-5 hover:text-warning text-success cursor-pointer" @click.stop="SaveWarehouseUser(tr, 'Update', '')" />
                  </vs-td>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";

// Cell Renderer

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      warehouseUserList: [],
      warehouseList: [],
      userList: [],
      warehouseSearch: { id: null, value: null },
      warehouseUserSearch: { userId: null, warehouseId: null },
      warehouseUserItem: { userId: null, warehouseId: null },
      showAddWarehouse: false,
      showSearchWarehouse: false,
    };
  },

  computed: {},
  methods: {
    getWarehouses: async function () {
      this.$vs.loading();
      this.warehouseList = await repository.postEntity("ParametricScreens/getWarehouse", this.warehouseSearch).then((r) => r.list);
      this.$vs.loading.close();
    },
    getUsers: async function () {
      this.userList = await repository.postEntity("HumanResource/getUser", { status: 1 }).then((r) => r.list);
    },

    getWarehouseUser: async function () {
      this.$vs.loading();
      this.warehouseUserList = await repository.postEntity("ParametricScreens/getWarehouseUser", this.warehouseUserSearch).then((r) => r.list);
      this.$vs.loading.close();
    },

    SaveWarehouseUser: async function (item, operation, messageText) {
      //Insert,Update,Delete
      item.operation = operation;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("ParametricScreens/SaveWarehouseUser", item);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.warehouseUserItem = {};
      this.warehouseUserSearch = {};
      this.getWarehouseUser();
    },
  },
  beforeMount() {},
  beforeUpdate() {},
  mounted() {},
  created: async function () {
    this.$vs.loading();
    await Promise.all([this.getWarehouseUser(), this.getWarehouses(), this.getUsers()]);
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
body {
  overflow: auto;
}
.vs-dialog {
  max-width: 1366px !important;
  max-height: 95% !important;
}
</style>
